import { HttpClient } from '@angular/common/http';
import { computed, inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthUser } from './auth.model';




@Injectable({
  providedIn: 'root',
})
export class AuthStateService {

  private http = inject(HttpClient);
  private router = inject(Router);

  // Reactive session state — no token stored here
  readonly currentUser = signal<AuthUser | null>(null);
  readonly isLoggedIn = signal(false);
  readonly permissions = computed(() => this.currentUser()?.permissions ?? []);
  // readonly isInitialized = signal(false); // ← guards wait for this

  hasPermission(permission: string): boolean {
    return this.permissions().includes(permission);
  }

  hasAnyPermission(permissions: string[]): boolean {
    return permissions.some(p => this.permissions().includes(p));
  }

  hasAllPermissions(permissions: string[]): boolean {
    return permissions.every(p => this.permissions().includes(p));
  }

  setSession(user: AuthUser): void {
    this.currentUser.set(user);
    this.isLoggedIn.set(true);
    // this.isInitialized.set(true);
  }

  clearSession(): void {
    this.currentUser.set(null);
    this.isLoggedIn.set(false);

    this.router.navigate(['/login']);
  }

  forceLogout(): void {
    this.clearSession();
    this.router.navigate(['/login']);
  }

  // POST /auth/refresh — browser auto-sends the refresh HttpOnly cookie
  // because the backend set path: '/auth/refresh'
  refresh(): Observable<void> {
    return this.http.post<void>('/auth/refresh', {}, { withCredentials: true });
  }

}
